// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__MpTqi"};